function t(t){return t*parseFloat(getComputedStyle(document.documentElement).fontSize)}function e(t,e){return(t%e+e)%e}export{t as convertRemToPixels,e as mod};
//# sourceMappingURL=math.js.map
